import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
const toggleStreamDataLakeConfigStatus = ({ streamIds, enabled }) => fetch("POST", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.stream_data_lake_set_config_status().url), {
  stream_ids: streamIds,
  enabled
});
const useStreamDataLakeStatusMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onToggleStreamDataLakeConfigStatus } = useMutation({
    mutationFn: toggleStreamDataLakeConfigStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake-config"]
      });
    },
    onError: (errorThrown) => {
      UserNotification.error(
        `Toggling Data Lake config status failed with status: ${errorThrown}`,
        "Toggling Data Lake config status"
      );
    }
  });
  return { onToggleStreamDataLakeConfigStatus };
};
export default useStreamDataLakeStatusMutation;
